import DarkButton from '@/components/ui/Buttons/SecondaryButton'
import Loader from '@/components/ui/loader'
import { useLanguage } from '@/context/LanguageContext'
import { useToast } from '@/context/ToastContext'
import { useMobiApi } from '@/services/mobi-api'
import { CreateInvoiceReq } from '@/services/mobi-api/invoice/types'
import { WIFICARD } from '@/services/mobi-api/wifiCard/types'
import { IMG_URL } from '@/utils/constants'
import useIntl from '@/utils/intl'
// import { HelpOutline } from '@mui/icons-material'
import { Divider, Radio, TextField } from '@mui/material'
import Image from 'next/image'
import React, { FunctionComponent, useEffect } from 'react'

interface Props {
  onClick: (payload: CreateInvoiceReq, option?: WIFICARD) => void
}

const Step1: FunctionComponent<Props> = ({ onClick }) => {
  const { showError } = useToast()
  const { card } = useMobiApi()
  const { locale } = useLanguage()
  const { translate } = useIntl()
  const [loading, setLoading] = React.useState(false)
  const [number, setNumber] = React.useState<string>('')
  const [dataList, setDataList] = React.useState<WIFICARD[] | undefined>()
  const [clickedOption, setClickedOption] = React.useState<
  WIFICARD | undefined
  >()

  const fetchData = async (isdn: string): Promise<void> => {
    try {
      setLoading(true)
      const res = await card.getList({ isdn })
      if (res !== undefined) {
        if (res?.error !== undefined) {
          setDataList([])
          const errStr =
            locale === 'en'
              ? res.cause?.messageEn ?? translate('error')
              : res.cause?.messageMn ?? translate('error')
          showError(errStr)
        }
        if (res.list !== undefined) {
          setDataList(res.list)
        }
      }
    } catch (e) {
      setDataList([])
      showError(translate('error'))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (number?.length !== 8) {
      setDataList([])
    }
  }, [number])

  const handleNumber = (value: string): void => {
    if (value.length < 9) {
      setNumber(value)
    }
    if (value.length === 8) {
      void fetchData(value)
    }
  }
  const handleNext = (): void => {
    if (clickedOption !== undefined) {
      const payload: CreateInvoiceReq = {
        isdn: number,
        products: [
          {
            productCode: clickedOption.productCode,
            productType: clickedOption.productType,
            price: clickedOption.price
          }
        ]
      }
      onClick(payload, clickedOption)
    }
  }
  return (
    <div className='bg-surfaceInverse rounded-xl md:shadow w-full h-full md:h-[75vh] md:w-fit flex flex-col justify-start overflow-auto relative'>
      <div className='sticky top-0 z-50 md:p-6 p-4 md:border-b bg-surfaceInverse border-secondaryMidStroke'>
        <TextField
          value={number}
          id='outlined-basic'
          label={translate('phoneNumber')}
          variant='outlined'
          className='w-full rounded-lg text-textHigh'
          type='number'
          onChange={(e) => {
            handleNumber(e.target.value)
          }}
          InputLabelProps={{
            style: { color: 'var(--color-text-textHigh)' }
          }}
          InputProps={{
            style: {
              color: 'var(--color-text-textHigh)',
              '&::placeholder': {
                color: 'var(--color-text-secondaryHighStroke)'
              }
            } as any
          }}
          sx={{
            '& fieldset': {
              borderRadius: '8px'
            }
          }}
        />
      </div>
      <div className='flex flex-grow overflow-auto flex-col md:p-8 p-4 md:h-full'>
        {loading && (
          <div className='w-full h-96 flex items-center justify-center'>
            <Loader />
          </div>
        )}
        {dataList !== undefined && dataList.length > 0
          ? (
            <div>
              {dataList.map((data, index: number) => (
                <div key={index} className='flex flex-col md:py-3'>
                  {/* <span className='text-sm text-[#111418] font-bold'>{locale === 'en' ? data.titleEn : data.titleMn}</span> */}
                  <div
                    className='flex pb-3 items-center justify-between md:w-96 cursor-pointer'
                    onClick={() => setClickedOption(data)}
                  >
                    <Image
                      draggable={false}
                      width={200}
                      height={200}
                      alt='img'
                      src={data.img ?? ''}
                      className='rounded-xl m-1 w-[112px]'
                    />
                    <div className='flex flex-col ml-3'>
                      <span className='text-sm text-textHigh font-medium mb-1'>
                        {locale === 'en' ? data.titleEn : data.titleMn}
                      </span>
                      <span className='text-textHigh font-bold'>
                        {data.price}₮
                      </span>
                    </div>

                    <Radio
                      checked={clickedOption?.productCode === data.productCode}
                      color='error'
                    />
                  </div>
                  <Divider />
                </div>
              ))}

            </div>
            )
          : (
            <div className='flex items-start gap-3 border border-[#F4A610] bg-[#FEFCF5] rounded-lg p-3 md:w-96'>
              <Image
                draggable={false}
                width={30}
                height={30}
                src={IMG_URL + '/uploads/icons/warning.svg'}
                alt='!'
              />
              <span className='text-xs text-[#78350F] font-medium ml-2'>
                {translate('bill.wifiCard.warning')}
              </span>
            </div>
            )}
      </div>
      <div className='fixed md:sticky bottom-0 right-0 left-0 z-50 md:p-6 p-4 border-t bg-surfaceInverse border-secondaryMidStroke'>
        <DarkButton
          fullwidth
          disabled={clickedOption === undefined || number.length !== 8}
          onClick={handleNext}
        >
          {translate('continue')}
        </DarkButton>
      </div>
    </div>
  )
}
export default Step1
